import React from "react"
import { Theme } from "@emotion/react"
import { Icon } from "@ncs/web-legos/components"

const ContactUs: React.FC = () => (
	<nav>
		<h2>Contact Us</h2>
		<ul>
			<li>
				<a href="mailto:Parts@NCSwash.com">
					<span aria-hidden="true">
						<Icon icon="envelope" color="white" />
					</span>
					Parts@NCSwash.com
				</a>
			</li>
			<li>
				<a href="mailto:VC-CustomerService@NCSwash.com">
					<span aria-hidden="true">
						<Icon icon="envelope" color="white" />
					</span>
					VC-CustomerService@NCSwash.com
				</a>
			</li>
			<li>
				<a href="tel:833-627-9274">
					<span aria-hidden="true">
						<Icon icon="phone" color="white" />
					</span>
					833-NCS-WASH
				</a>
			</li>
		</ul>
	</nav>
)

export default ContactUs
